import { FeatureFlagService } from "./services/FeatureFlag/feature-flag/feature-flag.service";

const featureFlag = new FeatureFlagService();

export default featureFlag;
